import { Grid, Link, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

export function MinimalFooter() {
    const { classes } = useStyles();

    return (
        <Grid
            container
            item
            direction="column"
            alignItems="center"
            spacing={2}
            justifyContent="center"
            mt={4}
            mb={2}
        >
            <Grid container item direction="row" wrap="wrap" spacing={4} justifyContent="center">
                <Grid item sx={{ textAlign: 'center' }}>
                    <Link
                        href="https://stayincontact.com/eula"
                        target="blank"
                        className={classes.linkText}
                    >
                        Terms of Service
                    </Link>
                </Grid>
                <Grid item sx={{ textAlign: 'center' }}>
                    <Link
                        href="https://consulnet.com/privacy"
                        target="blank"
                        className={classes.linkText}
                    >
                        Privacy Policy
                    </Link>
                </Grid>
                <Grid item sx={{ textAlign: 'center' }}>
                    <Link
                        href="https://consulnet.com/dmca"
                        target="blank"
                        className={classes.linkText}
                    >
                        DMCA Notices
                    </Link>
                </Grid>
            </Grid>
            <Grid item xs="auto">
                <Typography
                    component="p"
                    variant="caption"
                    align="center"
                    className={classes.linkText}
                >
                    For technical assistance, please visit{' '}
                    <Link href="https://successwebcare.com" className={classes.linkText}>
                        successwebcare.com
                    </Link>
                    .
                </Typography>
            </Grid>
            <Grid item xs="auto">
                <Link href="https://consulnet.com/" className={classes.linkText}>
                    © {new Date().getFullYear()} ConsulNet Computing
                </Link>
            </Grid>
        </Grid>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    linkText: {
        color: theme.palette.common.white,
    },
}));
